import React from 'react'
import { Tooltip } from 'antd'

const OverflowTooltip = (props: {
    content, width, className?
}) => {
    const { content, width, className } = props
    return (
        <Tooltip title={content}>
            <span className={className} style={{
                width: width,
                height: '22px',
                display: 'inline-block',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap'
            }}>{content}</span>
        </Tooltip>
    )
}

export default OverflowTooltip
